exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-head[data-v-ab6aa750]{color:#363636;font-weight:700}.lp-item-add[data-v-ab6aa750]{width:58px;height:30px;border-radius:3px;text-align:center;cursor:pointer;font-size:20px;border:1px solid}", ""]);

// exports
